import { HttpContext, httpResource } from '@angular/common/http';
import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HANDLE_HTTP_ERROR_LOCALLY } from '../../../core/http/http-context-tokens';

@Component({
  selector: 'app-icone-servico',
  template: '<span [innerHTML]="marcacao()"></span>',
  host: { class: 'icone-servico', 'aria-hidden': 'true' },
})
export class IconeServicoComponent {
  readonly icone = input.required<string>();

  private readonly sanitizer = inject(DomSanitizer);

  private readonly arquivo = httpResource.text(() => ({
    url: this.icone(),
    context: new HttpContext().set(HANDLE_HTTP_ERROR_LOCALLY, true),
  }));

  protected readonly marcacao = computed(() => {
    const svg = this.arquivo.value();
    return svg ? this.sanitizer.bypassSecurityTrustHtml(svg) : '';
  });
}
